import { map as _map } from 'lodash';
import { find as _find } from 'lodash';
import { filter as _filter } from 'lodash';

class ContactListController {
  constructor(authService, contactService, loadingService, lookupService, enums, $window, $ngConfirm, $scope, growl, $state) {
    "ngInject";

    if(!authService.validateUser(false, 'Company', enums.PERMISSION_TYPE.View, true)) { return; }

    this.authService = authService;
    this.contactService = contactService;
    this.loadingService = loadingService;
    this.lookupService = lookupService;
    this.enums = enums;
    this.$window = $window;
    this.$ngConfirm = $ngConfirm;
    this._$scope = $scope;
    this.growl = growl;
    this.$state = $state;

    this.selectOptions = {};
    this.selectDefaults = {};
    this.filterParams = {};

    this.initializeEnums();

    this.authService.getLocationExtendedProperties('telecomProvider');
  }

  initializeEnums() {
    const ctrl = this;
    const enumList = [
      {enumName: 'CONTACT_TYPE', propName: 'contactType', defaultOption: true, defaultOptionText: 'All Types'}
    ];

    enumList.map(item => {
      const enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName], item.defaultOption, item.defaultOptionText);
      ctrl.selectOptions[item.propName] = enumsArray;
      ctrl.selectDefaults[item.propName] = enumsArray[0];
      ctrl.updateModelFromSelect(item.propName);
    });

    this.reset();
  }

  convertEnumToKeyValueList(enumObj, defaultOption, defaultOptionText) {
    let objList = [];

    if (defaultOption) {
      objList.push({
        id: null,
        name: defaultOptionText || 'Please Select'
      })
    }

    for(let prop in enumObj){
      objList.push({
        id: enumObj[prop],
        name: prop
      });
    }

    return objList;
  }

  updateModelFromSelect(modelProperty, selectDefaultProperty = modelProperty, idProperty = 'id') {
    const val = this.selectDefaults[selectDefaultProperty][idProperty];
    eval(`this.filterParams.${modelProperty} = ${val}`);
  }

  reset() {
    const ctrl = this;

    this.selectDefaults.contactType = this.selectOptions.contactType[0];

    this.filterParams.entityId = this.authService.authData.currentLocation.key;
    this.filterParams.contactType = this.selectDefaults.contactType.id;
    this.filterParams.contactName = '';
    this.filterParams.companyName = '';
    this.filterParams.ownerName = '';

    this.pagination = {
      totalItems: 0,
      currentPage: 1,
      pageSize: 10
    };

    this.filterParams.pageCriteria = {
      pageStart: 0,
      itemsToFetch: this.pagination.pageSize,
      sortExpression: 'companyId',
      ascending: true
    };

    this.notification = {
      type: 'info',
      msg: ''
    };

    this.listContacts();
  }

  updatePageIndex() {
    if (this.pagination.currentPage === 1) {
      this.filterParams.pageCriteria.pageStart = 0;
    }
    else {
      this.filterParams.pageCriteria.pageStart = ((this.pagination.currentPage-1) * this.pagination.pageSize);
    }
  }

  updateSort(fieldName) {
    if (this.filterParams.pageCriteria.sortExpression === fieldName) {
      this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
    }
    else {
      this.filterParams.pageCriteria.sortExpression = fieldName;
      this.filterParams.pageCriteria.ascending = true;
    }

    this.listContacts();
  }

  listContacts() {
    const ctrl = this;

    ctrl.updatePageIndex();

    ctrl.loadingService.showLoading('contactListing', 'Loading Contacts ...');

    ctrl.contactService.listContacts(ctrl.filterParams)
      .then(response => {
        ctrl.contacts = response.data.items;
        ctrl.pagination.totalItems = response.data.totalRecords;

        if (ctrl.pagination.totalItems === 0) {
          ctrl.notification = {
            type: 'info',
            msg: `No data to display`
          }
        }
        else {
          const pageEnd = (ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize) < response.data.totalRecords ? (ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize) :  response.data.totalRecords;

          ctrl.notification = {
            type: 'info',
            msg: `Currently display ${(ctrl.filterParams.pageCriteria.pageStart+1)} to ${pageEnd} out of ${ctrl.pagination.totalItems} contacts`
          }
        }
      })
      .catch(err => {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while fetching vehicles." + (err.data ? err.data.messageDetail : '')
        }
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('contactListing');
      });
  }

  deleteContact(contactId) {
    const ctrl = this;
    let sure, state;

    sure = this.$window.confirm(`Are you sure you want to delete this Contact ?`)

    if (!sure) {
      return;
    }

    this.loadingService.showLoading('contactListing', 'Removing Contact ...');

    ctrl.contactService.updateContactState(this.authService.authData.currentLocation.key, contactId, this.enums.OBJECT_ROW_STATE.Deleted)
      .then(response => {
        ctrl.listContacts();
      })
      .catch(err => {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while updating contact state. " + err.data.messageDetail ? err.data : err.data.messageDetail
        }
      })
      .finally(() => {
        this.loadingService.hideLoading('contactListing');
      });
    }

  canEdit(contact) {
    const ctrl = this;
    let retValue = false;
    
    retValue = ctrl.authService.checkFeatureAccess('Contact', ctrl.enums.PERMISSION_TYPE.Edit, false);

    return retValue;
  }

  showExportContactsToTelecomProvider() {
    this._$scope.telecomProviderName = this.authService.authData.currentLocation.telecomProvider.name;
    this._$scope.inProgress = false;
    this._$scope.completed = false;
    this._$scope.editContact = (contactId) => {
      this._$scope.exportDialog.close();
      this.$state.go('contactEdit', {contactId});
    }

    this._$scope.exportDialog = this.$ngConfirm({
      title: 'Export Contacts',
      contentUrl: `templates/contact/exportContactsTemplate`,
      scope: this._$scope,
      columnClass: 'm',
      type: 'dark',
      buttons: {
        confirm: {
            text: 'Confirm',
            btnClass: 'btn-primary',
            action: this.exportContactsToTelecomProvider.bind(this),
        },
        cancel: {
          text: 'Leave It',
          btnClass: 'btn-default'
        }
      }          
    });   
  }

  exportContactsToTelecomProvider() {
    this._$scope.exportDialog.buttons.confirm.setShow(false);
    this._$scope.exportDialog.buttons.cancel.setShow(false);
    
    this._$scope.inProgress = true;

    this.contactService.exportContactsToTelecomProvider(this.authService.authData.currentLocation.key)
      .then(response => {       
        this._$scope.completed = true;
        this._$scope.stats = response.data;        

        this._$scope.exportDialog.buttons.cancel.setText('Close');
        this._$scope.exportDialog.buttons.cancel.setShow(true);
      })
      .catch(err => {
        this._$scope.exportDialog.close();
        this.growl.error('An error occurred while exporting contacts. Please contact system administrator', {ttl: 5000});
      });    

    return false;    
  }
}

export default ContactListController;



// WEBPACK FOOTER //
// ./client/app/components/contact/contactList/contactList.controller.js